import styled from "styled-components";
import Reveal from "../ui/Reveal";
import SectionLabel from "../ui/SectionLabel";
import { Tags } from "../ui/Tag";
import { projects } from "../../data/projects";

function Projects() {
  return (
    <WorkSection id="work" aria-labelledby="work-heading">
      <WorkTitle>
        <div>
          <SectionLabel>Selected work</SectionLabel>
          <h2 id="work-heading">
            Projects made to be <em>explored.</em>
          </h2>
        </div>
        <p>Full-stack builds shipped during recent internships, from database schema to production UI.</p>
      </WorkTitle>
      <ProjectGrid>
        {projects.map((project, index) => (
          <Reveal as="div" delay={index * 0.08} key={project.id}>
            <ProjectCard>
              <ProjectNumber>0{index + 1}</ProjectNumber>
              <h3>{project.name}</h3>
              <Status>{project.status}</Status>
              <p className="context">{project.context}</p>
              <p>{project.details}</p>
              <ContributionLabel>My contribution</ContributionLabel>
              <p>{project.contribution}</p>
              <Tags items={project.tech} />
            </ProjectCard>
          </Reveal>
        ))}
      </ProjectGrid>
    </WorkSection>
  );
}

const WorkSection = styled.section`
  background: var(--bg-inverted);
  color: var(--text-on-inverted);
  padding: 100px max(28px, calc((100vw - 1184px) / 2));
  --section-label-color: var(--accent-on-inverted);

  @media (max-width: 700px) {
    padding: 70px 24px;
  }
`;

const WorkTitle = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 60px;
  align-items: end;
  margin-bottom: 55px;

  h2 {
    margin: 0;
    font-size: clamp(2.1rem, 4.6vw, 3.6rem);
    line-height: 1.05;
    letter-spacing: -0.03em;
  }

  em {
    font-family: Georgia, serif;
    color: var(--accent-on-inverted);
    font-weight: 400;
    font-style: normal;
  }

  p {
    color: var(--text-on-inverted-muted);
    max-width: 300px;
    font-size: 0.95rem;
    line-height: 1.6;
    margin: 0;
  }

  @media (max-width: 700px) {
    display: block;
    p {
      margin-top: 25px;
    }
  }
`;

const ProjectGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 25px;

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;

const ProjectCard = styled.article`
  position: relative;
  height: 100%;
  border: 1px solid var(--border-inverted);
  border-radius: 8px;
  padding: 28px 26px 26px;
  transition: border-color 0.2s ease, transform 0.2s ease;

  &:hover {
    border-color: var(--accent-on-inverted);
    transform: translateY(-3px);
  }

  h3 {
    font-size: 1.5rem;
    letter-spacing: -0.02em;
    margin: 8px 0 6px;
  }

  p {
    font-size: 0.88rem;
    line-height: 1.65;
    color: var(--text-on-inverted-muted);
    margin: 0 0 14px;
  }

  p.context {
    color: var(--accent-on-inverted);
    font-weight: 600;
    font-size: 0.82rem;
  }
`;

const ProjectNumber = styled.span`
  font-size: 0.68rem;
  font-weight: 800;
  color: var(--accent-on-inverted);
  letter-spacing: 0.08em;
`;

const Status = styled.div`
  display: inline-block;
  font-size: 0.68rem;
  font-weight: 700;
  color: var(--text-on-inverted);
  background: color-mix(in srgb, var(--text-on-inverted) 12%, transparent);
  border-radius: 20px;
  padding: 5px 11px;
  margin-bottom: 16px;
`;

const ContributionLabel = styled.div`
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 800;
  color: var(--text-on-inverted-muted);
  margin-bottom: 8px;
`;

export default Projects;
